import Person from './person';
import PersonAccess from './person-access';
import PersonVehicle from './person-vehicle';

export default {Person, PersonAccess, PersonVehicle}
export{Person, PersonAccess, PersonVehicle}
